import "./Anchor.css";

export default function Anchor({ text, href, target = "_self", rel = undefined, additionalClassNames = undefined }) {
  return (
    <a className={`anchor ${additionalClassNames}`} target={target} rel={rel} href={href}>
      {text}
    </a>
  );
}
